<!--<div class="tdo-note-dialog-main">-->
@if (isLoading) {
  <app-tdo-progress-spinner style="position: absolute; top: 50%; left: calc(50% - 46px);" data-cy="imaging-source-spinner"></app-tdo-progress-spinner>
}
<div style="flex: 1; display: flex; flex-direction: column; width: 100%;" data-cy="imaging-source-container">
  <div style="background-color: var(--tdo-primary); color: white; flex-basis: 30px;" data-cy="imaging-source-header">
    <span style="position: relative; left: 8px; top: 6px;" data-cy="imaging-source-title">{{message}}</span>
  </div>
  <div style="flex-basis: 220px; display: flex; flex-direction: column;" data-cy="imaging-source-content">
    <div style="flex: 1;" data-cy="imaging-source-selection-area">
      @if (isErrorFindingTwainDrivers) {
        <div style="width: fit-content; position: relative; margin-top: 80px; margin-left: auto; margin-right: auto;" data-cy="imaging-source-error-message">
          Unable to locate twain drivers
        </div>
      }
      @if (!isErrorFindingTwainDrivers) {
        <div data-cy="imaging-source-drivers-container">
          <mat-form-field appearance="fill" data-cy="imaging-source-form-field">
            @if (twainsources) {
              <div data-cy="imaging-source-list-container">
                <p data-cy="imaging-source-list-wrapper">
                  <mat-card-content data-cy="imaging-source-card-content">
                    <mat-select [(value)]="selectedTwain" data-cy="imaging-source-dropdown">
                      @for (twainsource of twainsources; track twainsource) {
                        <mat-option [value]="twainsource" data-cy="imaging-source-option">
                          {{twainsource}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-card-content>
                </p>
              </div>
            }
          </mat-form-field>
        </div>
      }
    </div>
    <div style="display: flex; flex-basis: 44px; width: 100%; padding: 2px;" data-cy="imaging-source-buttons-container">
      <button (click)="cancel()" class="tdo-button primary-accent" style="margin-left: 270px; margin-right: 6px;" data-cy="imaging-source-cancel-button">Cancel</button>
      <button (click)="confirm()" [disabled]="isConfirmDisabled" class="tdo-button primary-accent" data-cy="imaging-source-confirm-button">Confirm</button>
    </div>
  </div>
</div>
<!--</div>-->

<!--<div class="main-container">
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner style="margin:0 auto;"></mat-spinner>
</div>

&lt;!&ndash;<mat-grid-list cols="1" rowHeight="100%" style="height:100%;">
<mat-grid-tile colspan="1">&ndash;&gt;
  <mat-card style="width:100%; height:100%;">
    <mat-card-header>
      <div></div>
      <mat-card-title>{{ message }}</mat-card-title>
    </mat-card-header>

    <b></b>

    <mat-divider></mat-divider>

    &lt;!&ndash;<mat-form-field appearance="fill">
    <mat-form-field >&ndash;&gt;

      <div *ngIf="twainsources">
        <p>
          <mat-card-content>
            <mat-select [(value)]="selectedTwain">
              <mat-option *ngFor="let twainsource of twainsources" [value]="twainsource">
                {{twainsource}}
              </mat-option>
            </mat-select>
          </mat-card-content>
        </p>
      </div>


      &lt;!&ndash;<p>
      <mat-card-content>
        <mat-select [(value)]="selectedTwain">
          <mat-option *ngFor="let twainsource of twainsources" [value]="twainsource.value">
            {{twainsource.viewValue}}
          </mat-option>
        </mat-select>
      </mat-card-content>
    </p>&ndash;&gt;

    <mat-divider></mat-divider>

  &lt;!&ndash;</mat-form-field>&ndash;&gt;
  <b></b>
  <b></b>
  <p>
    <mat-card-actions>
      <button mat-raised-button style="float: right;" (click)="confirm()">Confirm</button>
      <button mat-raised-button style="float: right;" (click)="cancel()">Cancel</button>
    </mat-card-actions>
  </p>


</mat-card>


&lt;!&ndash;</mat-grid-tile>

</mat-grid-list>&ndash;&gt;
</div>-->
